import fr from 'facet-rest';
import { fullGeneralDateWithDay } from 'Consts/DateFormats';
import moment from 'moment';
import { currency } from 'Helpers/Formats';
import InlineReadOnlyField from 'Components/UI/Overrides/InlineReadOnlyField';

const fieldsToHide = [
  'householdId',
  'primaryClientFullName',
  'saveAgentFullName',
  'status',
  'escalatedReason',
];

const formatDate = (v) => moment.utc(v).format(fullGeneralDateWithDay);
const formatAum = (v) => (v === '1' ? 'Yes' : 'No');
const formatDollar = (v) => currency(v, true);
const formatSchedule = (v) => {
  switch (v) {
    case 'month':
      return 'Monthly';
    case 'year':
      return 'Yearly';
    default:
      return v;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const ClientExperienceSavesHouseholdInfoOverride = fr.metaOverride()
  .overrideAll({
    _component: () => InlineReadOnlyField,
  },
  {
    ordinal: 200,
  })
  .nameOverride(fieldsToHide, { hidden: true })
  .nameOverride('leadPlannerFullName', {
    ordinal: 0,
  })
  .nameOverride('csManagerFullName', {
    ordinal: 1,
  })
  .nameOverride('serviceLevel', {
    ordinal: 2,
    _formatReadOnly: () => formatDollar,
  },
  {
    ordinal: 202,
  })
  .nameOverride('paymentMethod', {
    ordinal: 3,
  })
  .nameOverride('paymentSchedule', {
    ordinal: 4,
    _formatReadOnly: () => formatSchedule,
  },
  {
    ordinal: 203,
  })
  .nameOverride('assetsUnderManagement', {
    ordinal: 5,
    _formatReadOnly: () => formatAum,
  },
  {
    ordinal: 204,
  })
  .nameOverride('householdIncome', {
    ordinal: 6,
    _formatReadOnly: () => formatDollar,
  })
  .nameOverride('anniversaryDate', {
    ordinal: 7,
    _formatReadOnly: () => formatDate,
  },
  {
    ordinal: 205,
  })
  .nameOverride('escalationTime', {
    ordinal: 8,
    _formatReadOnly: () => formatDate,
  },
  {
    ordinal: 206,
  });
